import { render, staticRenderFns } from "./InboundLoadStatus.vue?vue&type=template&id=7586e80c&"
import script from "./InboundLoadStatus.vue?vue&type=script&lang=js&"
export * from "./InboundLoadStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports